import { useState } from "react";
import { useTranslation } from "react-i18next";
import { API } from "../../services/axios";
import { URLS } from "../../services/urls";
import { toast } from "react-toastify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPaperPlane, faEnvelopeOpenText, faShieldAlt } from "@fortawesome/free-solid-svg-icons";
import "../../pages/home/Home.css"; // Assurez-vous que ce fichier contient les styles CSS ci-dessous

const NewsLetter = () => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState("");

  const handleSubmit = (event) => {
    event.preventDefault();
    
    if (!email) return;

    setLoading(true);
    
    // Envoi à l'API
    API.post(URLS.NEWSLETTER.SUBSCRIPTION.create, { email })
      .then((resp) => {
        setLoading(false);
        toast.success(t("textThankForSubscribing"));
        setEmail(""); // On vide le champ après succès
      })
      .catch((error) => {
        console.log(error?.response?.data);
        setLoading(false);
        toast.error(error?.response?.data?.email[0] ?? t("textNewsletterFailed"));
      });
  };

  return (
    <section className="section-box mt-50 mb-50">
      <div className="container">
        
        {/* Carte Newsletter Moderne */}
        <div className="newsletter-modern-card position-relative overflow-hidden wow animate__animated animate__fadeInUp">
          
          {/* Cercles décoratifs en arrière-plan */}
          <div className="bg-circle-1"></div>
          <div className="bg-circle-2"></div>

          <div className="row align-items-center position-relative z-1">
            
            {/* Colonne Gauche : Texte + Icône */}
            <div className="col-lg-6 col-md-12 mb-4 mb-lg-0">
              <div className="d-flex align-items-center flex-column flex-sm-row text-center text-sm-start">
                <div className="newsletter-icon-wrapper mb-3 mb-sm-0 me-sm-4">
                    <FontAwesomeIcon icon={faEnvelopeOpenText} className="text-white" />
                </div>
                <div>
                    <h3
                        className="text-white fw-bold mb-2"
                        dangerouslySetInnerHTML={{ __html: t("textNewsWill") }}
                    ></h3>
                    <p className="text-white-50 mb-0 font-md">
                        Rejoignez notre communauté pour ne manquer aucune opportunité.
                    </p>
                </div>
              </div>
            </div>

            {/* Colonne Droite : Formulaire */}
            <div className="col-lg-6 col-md-12">
              <div className="box-form-newsletter ps-lg-5">
                <form className="form-newsletter-modern" onSubmit={handleSubmit}>
                  <div className="input-group-modern">
                    <input
                      className="form-control border-0 bg-transparent text-white placeholder-white"
                      required
                      type="email"
                      name="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      placeholder={t("textEnterEmail") || "Votre adresse email..."}
                    />
                    <button
                      className="btn btn-light fw-bold px-4 py-2 m-1 rounded-pill"
                      type="submit"
                      disabled={loading}
                    >
                      {loading ? (
                        <div className="spinner-border spinner-border-sm text-primary" role="status"></div>
                      ) : (
                        <>
                            <span className="d-none d-sm-inline">{t("textSubscribe")}</span>
                            <FontAwesomeIcon icon={faPaperPlane} className="ms-sm-2 text-primary" />
                        </>
                      )}
                    </button>
                  </div>
                </form>
                
                {/* Texte de réassurance (Anti-spam) */}
                <div className="mt-3 text-white-50 small d-flex align-items-center justify-content-center justify-content-lg-start">
                    <FontAwesomeIcon icon={faShieldAlt} className="me-2" />
                    <span>Pas de spam, désabonnement à tout moment.</span>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </section>
  );
};

export default NewsLetter;